import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import initialState from './updateProfB2FormInitialState';
import axios from 'axios';
import {
  _setIsProfB2DataLoaded,
  _setAlcohol,
  _setMethamphetamine,
  _setCocaine,
  _setHeroin,
  _setMarijuanaHash,
  _setEcstacy,
  _setPCP,
  _setLSDHallucinogens,
  _setInhalants,
  _setPrescription,
  _setPolyDrugUser,
  _setSubstanceUseHistoryOther,
  _setSubstanceUseHistoryComment,
  _setPA2ConcernsNone,
  _setSex,
  _setArson,
  _setViolence,
  _setChildAbuse,
  _setDomesticViolence,
  _setPOC,
  _setWeapons,
  _setGangs,
  _setEnemies,
  _setADA,
  _setMedical,
  _setPsychiatric,
  _setVictims,
  _setElderAbuse,
  _setPA2ConcernsOthers,
  _setPA2DirectionsNone,
  _setNoCoEdProgram,
  _setNoContactwithMinors,
  _setNoFOTEP,
  _setMedicalConcerns,
  _setPA2DirectionsComments,
  _setTIP,
  _setFOTEP,
  _setEligibleTo2933,
  _setInEligibleTo2933,
  _setOSAPAgentsGeneralComments,
  _setDateScreened,
  _setOSAPParoleAgentId,
} from './profB2FormActions';
const STOP_REGION = process.env.REACT_APP_STOP_REGION

export const getProfB2Form = createAsyncThunk(
  'stop/getProfB2Form',
  async (params) => {
    const { profB2TabUrl, authorization } = params;
    const config = {
      headers: {
        Authorization: authorization,
        Region: STOP_REGION
      },
    };
    const response = await axios
      .get(profB2TabUrl, config)
      .then((response) => {
        return response;
      })
      .catch((e) => {
        console.log(e);
        return e;
      });

    const data = await response.data.data;
    return data === undefined ? null : data;
  }
);

const profB1Slice = createSlice({
  name: 'stop/profB2',
  initialState,
  reducers: {
    setIsProfB2DataLoaded: _setIsProfB2DataLoaded,
    setAlcohol: _setAlcohol,
    setMethamphetamine: _setMethamphetamine,
    setCocaine: _setCocaine,
    setHeroin: _setHeroin,
    setMarijuanaHash: _setMarijuanaHash,
    setEcstacy: _setEcstacy,
    setPCP: _setPCP,
    setLSDHallucinogens: _setLSDHallucinogens,
    setInhalants: _setInhalants,
    setPrescription: _setPrescription,
    setPolyDrugUser: _setPolyDrugUser,
    setSubstanceUseHistoryOther: _setSubstanceUseHistoryOther,
    setSubstanceUseHistoryComment: _setSubstanceUseHistoryComment,
    setPA2ConcernsNone: _setPA2ConcernsNone,
    setSex: _setSex,
    setArson: _setArson,
    setViolence: _setViolence,
    setChildAbuse: _setChildAbuse,
    setDomesticViolence: _setDomesticViolence,
    setPOC: _setPOC,
    setWeapons: _setWeapons,
    setGangs: _setGangs,
    setEnemies: _setEnemies,
    setADA: _setADA,
    setMedical: _setMedical,
    setPsychiatric: _setPsychiatric,
    setVictims: _setVictims,
    setElderAbuse: _setElderAbuse,
    setPA2ConcernsOthers: _setPA2ConcernsOthers,
    setPA2DirectionsNone: _setPA2DirectionsNone,
    setNoCoEdProgram: _setNoCoEdProgram,
    setNoContactwithMinors: _setNoContactwithMinors,
    setNoFOTEP: _setNoFOTEP,
    setMedicalConcerns: _setMedicalConcerns,
    setPA2DirectionsComments: _setPA2DirectionsComments,
    setTIP: _setTIP,
    setFOTEP: _setFOTEP,
    setEligibleTo2933: _setEligibleTo2933,
    setInEligibleTo2933: _setInEligibleTo2933,
    setOSAPAgentsGeneralComments: _setOSAPAgentsGeneralComments,
    setDateScreened: _setDateScreened,
    setOSAPParoleAgentId: _setOSAPParoleAgentId,
  },
  extraReducers: {
    [getProfB2Form.fulfilled]: (state, action) => action.payload,
  },
});

export const {
  setIsProfB2DataLoaded,
  setAlcohol,
  setMethamphetamine,
  setCocaine,
  setHeroin,
  setMarijuanaHash,
  setEcstacy,
  setPCP,
  setLSDHallucinogens,
  setInhalants,
  setPrescription,
  setPolyDrugUser,
  setSubstanceUseHistoryOther,
  setSubstanceUseHistoryComment,
  setPA2ConcernsNone,
  setSex,
  setArson,
  setViolence,
  setChildAbuse,
  setDomesticViolence,
  setPOC,
  setWeapons,
  setGangs,
  setEnemies,
  setADA,
  setMedical,
  setPsychiatric,
  setVictims,
  setElderAbuse,
  setPA2ConcernsOthers,
  setPA2DirectionsNone,
  setNoCoEdProgram,
  setNoContactwithMinors,
  setNoFOTEP,
  setMedicalConcerns,
  setPA2DirectionsComments,
  setTIP,
  setFOTEP,
  setEligibleTo2933,
  setInEligibleTo2933,
  setOSAPAgentsGeneralComments,
  setDateScreened,
  setOSAPParoleAgentId,
} = profB1Slice.actions;

export default profB1Slice.reducer;
